/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Strength_BodyInputs */

const en_for_whom_strength_body = /** @type {(inputs: For_Whom_Strength_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach's plan adds weight when you are ready, and every best set lands on the chart. You see the progress before you feel it on the bar.`)
};

const pl_for_whom_strength_body = /** @type {(inputs: For_Whom_Strength_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan od trenera dokłada ciężar wtedy, kiedy jesteś gotowy, a każda najlepsza seria trafia na wykres. Postęp widzisz, zanim poczujesz go na sztandze.`)
};

/**
* | output |
* | --- |
* | "Your coach's plan adds weight when you are ready, and every best set lands on the chart. You see the progress before you feel it on the bar." |
*
* @param {For_Whom_Strength_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_strength_body = /** @type {((inputs?: For_Whom_Strength_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Strength_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_strength_body(inputs)
	return en_for_whom_strength_body(inputs)
});